import clsx from 'clsx';
import React from 'react';

export interface BaseInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  errorMessage?: string;
  classNameInput?: string;
  classNameWrapper?: string;
  leftIcon?: React.ReactNode;
}

const BaseInput = React.forwardRef<HTMLInputElement, BaseInputProps>(
  (
    {
      name,
      label,
      errorMessage = '',
      classNameInput,
      classNameWrapper,
      leftIcon,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={clsx('relative w-full h-full', classNameWrapper)} style={props.style}>
        {label && (
          <label className="form-label text-md font-medium dark:text-white" htmlFor={name}>
            {label}: <span className="text-brand-500">*</span>
          </label>
        )}

        {leftIcon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {leftIcon}
          </div>
        )}

        <input
          id={name}
          name={name}
          ref={ref}
          type={props.type ?? 'text'}
          className={clsx(
            'form-input w-full px-4 py-3 rounded-xl text-sm border focus:outline-none transition-colors duration-200',
            leftIcon ? 'pl-10' : '',
            classNameInput,
            {
              'border-red-500 focus:ring-2 focus:ring-red-500 focus:border-transparent': !!errorMessage,
              'border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-brand-500 focus:border-transparent dark:focus:ring-brand-500': !errorMessage,
            },
            props.disabled
              ? 'bg-gray-100 dark:bg-gray-700 dark:text-gray-400 dark:opacity-60 cursor-not-allowed'
              : 'bg-white dark:bg-gray-800 dark:text-slate-200',
          )}
          {...props}
        />

        {errorMessage && <p className="text-red-500 text-xs mt-1">{errorMessage}</p>}
      </div>
    );
  },
);

BaseInput.displayName = 'BaseInput';

export default BaseInput;
